import LoadingData from './loading-data';

export default LoadingData;